import { ButtonHTMLAttributes } from 'react'
import type { IconElement } from './icons'

export enum ButtonKind {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Floating = 'floating'
}

export enum ButtonSize {
  Small = 'small',
  Base = 'base',
  Large = 'large'
}

type ButtonSizeOptions =
  | { sm?: false; md?: true; lg?: false }
  | { sm: true; md?: false; lg?: false }
  | { sm?: false; md?: false; lg: true }

export interface BaseButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'size'> {
  disabled?: boolean
  size?: ButtonSize
  kind?: ButtonKind
  loading?: boolean
  leftIcon?: IconElement
  rightIcon?: IconElement
}

export type ButtonProps = Omit<BaseButtonProps, 'kind' | 'size'> & ButtonSizeOptions

export type ButtonBarrelComponent = React.FC<BaseButtonProps> & {
  Primary: React.FC<ButtonProps>
  Secondary: React.FC<ButtonProps>
  Tertiary: React.FC<ButtonProps>
  Floating: React.FC<ButtonProps>
  Submit: React.FC<ButtonProps>
}
